import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { trackAddToCart } from '../utils/metaPixel';
const CHECKOUT_URL = 'https://www.nutricioncaninafacil.shop/cart/53464991138005:1?checkout';
const bonuses = [{
  title: 'Snacks naturales para perros',
  desc: 'Recetas fáciles y saludables para premiar a tu perro sin darle alimentos ultraprocesados.',
  value: '$3.000',
  image: 'https://cdn.magicpatterns.com/uploads/ofabnShPqoGBR45cvtTULU/bono1.webp'
}, {
  title: 'Guía de suplementos naturales',
  desc: 'Qué suplementos usar, cuándo y en qué cantidad para mejorar su salud.',
  value: '$3.500',
  image: 'https://cdn.magicpatterns.com/uploads/evvUDYPLFZzAtgnKJa31pZ/bono2.webp'
}, {
  title: 'Plan de alimentación natural de 30 días',
  desc: 'Un plan listo para aplicar sin tener que pensar qué darle cada día.',
  value: '$4.000',
  image: 'https://cdn.magicpatterns.com/uploads/jTQ812xVe2haxfdXLQwYr3/bono3.webp'
}, {
  title: 'Cómo elegir el mejor alimento balanceado',
  desc: 'Aprendé a identificar ingredientes de mala calidad y elegir la mejor opción posible.',
  value: '$2.500',
  image: 'https://cdn.magicpatterns.com/uploads/1ZdonrGLSYxxYHssLP75sP/bono4.webp'
}, {
  title: 'Soluciones para problemas digestivos',
  desc: 'Qué darle si tu perro tiene diarrea, vómitos o sensibilidad digestiva.',
  value: '$3.000',
  image: 'https://cdn.magicpatterns.com/uploads/bg1PzXSBtucVXMnGwAET8e/bono5.webp'
}, {
  title: 'Soluciones para problemas de piel y pelo',
  desc: 'Alimentos y estrategias para mejorar picazón, caída de pelo y alergias.',
  value: '$3.000',
  image: 'https://cdn.magicpatterns.com/uploads/2LcSuKciSjgsKRmCnTjhxu/bono6.webp'
}, {
  title: 'Lista de compras práctica',
  desc: 'Para que sepas exactamente qué comprar y no pierdas tiempo ni dinero.',
  value: '$2.000',
  image: 'https://cdn.magicpatterns.com/uploads/hZjEUW41w6bRcWjkPWAmHs/bono7.webp'
}];
export function ValueStack() {
  return <section className="py-10 md:py-12 px-4 bg-cream" data-id="element-217">
      <div className="max-w-5xl mx-auto" data-id="element-218">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-center mb-12" data-id="element-219">
          <h2 className="text-3xl md:text-4xl font-bold text-charcoal mb-4" data-id="element-220">
            Además del ebook principal, hoy te llevás{' '}
            <span className="text-accent" data-id="element-221">7 bonos exclusivos</span>
          </h2>
          <div className="w-24 h-1 bg-accent mx-auto rounded-full" data-id="element-222"></div>
        </motion.div>

        <div className="space-y-3 mb-12" data-id="element-223">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="bg-white p-3 md:p-4 rounded-xl shadow-sm border border-sage flex flex-col items-start gap-2 relative overflow-hidden group hover:shadow-md transition-shadow" data-id="element-224">
              <div className="absolute left-0 top-0 bottom-0 w-1 bg-accent" data-id="element-225"></div>

              <div className="flex items-center gap-3 md:gap-4 ml-2" data-id="element-226">
                {bonus.image ? <img src={bonus.image} alt={bonus.title} className="w-[80px] object-contain rounded-md flex-shrink-0" loading="lazy" decoding="async" width={80} height={100} data-id="element-227" /> : <div className="w-[80px] h-[80px] rounded-md bg-orange-50 flex items-center justify-center flex-shrink-0 border border-orange-100" data-id="element-228">
                    <span className="text-2xl" data-id="element-229">🎁</span>
                  </div>}
                <div data-id="element-230">
                  <div className="inline-block px-2 py-0.5 bg-accent/10 text-accent text-[10px] font-bold rounded mb-0.5" data-id="element-231">
                    BONUS {index + 1}
                  </div>
                  <h3 className="text-base font-bold text-charcoal font-serif leading-snug" data-id="element-232">
                    {bonus.title}
                  </h3>
                </div>
              </div>

              <p className="text-gray-600 text-xs md:text-sm leading-relaxed ml-2" data-id="element-233">
                {bonus.desc}
              </p>

              <div className="flex items-center gap-2 ml-2" data-id="element-234">
                <span className="inline-flex items-center px-2 py-0.5 bg-primary/10 text-primary text-[10px] font-bold uppercase tracking-wider rounded-full" data-id="element-235">
                  🎉 Regalo
                </span>
                <span className="text-gray-400 text-xs font-medium line-through decoration-red-400/70 decoration-2" data-id="element-236">
                  Valor: {bonus.value}
                </span>
                <span className="text-sm font-extrabold text-primary" data-id="element-237">
                  HOY GRATIS
                </span>
              </div>
            </motion.div>)}
        </div>

        {/* Total Value Box */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="block bg-white border-2 border-primary/20 p-6 rounded-3xl shadow-xl text-center relative overflow-hidden" data-id="element-238">
          <div className="relative z-10" data-id="element-239">
            <p className="text-lg text-gray-500 mb-2 font-medium" data-id="element-240">
              Valor total de todo el paquete:
            </p>
            <p className="text-3xl md:text-4xl font-bold line-through text-gray-400 mb-3 decoration-red-500/70 decoration-4" data-id="element-241">
              $36.000
            </p>
            <p className="text-lg text-accent font-bold mb-2 uppercase tracking-wider" data-id="element-242">
              Llevate todo hoy por solo:
            </p>
            <p className="md:text-7xl font-bold text-primary drop-shadow-sm font-serif text-[48px]" data-id="element-243">
              $15.999
            </p>
          </div>
        </motion.div>

        {/* Standalone CTA Button */}
        <div className="mt-5 flex justify-center" data-id="element-244">
          <motion.a href={CHECKOUT_URL} onClick={(e: React.MouseEvent) => {
          e.preventDefault();
          trackAddToCart();
          window.location.href = CHECKOUT_URL;
        }} whileHover={{
          scale: 1.03,
          filter: 'brightness(1.08)'
        }} whileTap={{
          scale: 0.97
        }} className="inline-flex items-center justify-center px-8 py-3.5 text-base md:text-lg font-bold text-white rounded-full shadow-lg hover:bg-[#B45309] hover:shadow-2xl transition-all duration-300 cursor-pointer select-none uppercase tracking-wider bg-[#2D5016]" data-id="element-245">
            TOCÁ ACÁ PARA EMPEZAR
          </motion.a>
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.3
      }} className="mt-12 text-center max-w-2xl mx-auto" data-id="element-246">
          <p className="text-gray-700 font-medium italic bg-[#FFFBF5] text-[16px]" data-id="element-247">
            "No es solo información… Es la tranquilidad de saber que estás
            alimentando bien a tu perro, sin dudas, sin errores y con un sistema
            claro que podés aplicar desde hoy."
          </p>
        </motion.div>
      </div>
    </section>;
}